// src/store/slices/empleadosSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EmpleadoService from 'services/EmpleadoService';

export const fetchEmpleados = createAsyncThunk(
    'empleados/fetchAll',
    async (params, { rejectWithValue }) => {
        try {
            return await EmpleadoService.getAll(params);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar empleados');
        }
    }
);

export const createEmpleado = createAsyncThunk(
    'empleados/create',
    async (data, { rejectWithValue }) => {
        try {
            return await EmpleadoService.create(data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const updateEmpleado = createAsyncThunk(
    'empleados/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            return await EmpleadoService.update(id, data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const deleteEmpleado = createAsyncThunk(
    'empleados/delete',
    async (id, { rejectWithValue }) => {
        try {
            await EmpleadoService.remove(id);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al eliminar');
        }
    }
);

export const updateEmpleadoEstado = createAsyncThunk(
    'empleados/updateEstado',
    async ({ id, activo }, { rejectWithValue }) => {
        try {
            return await EmpleadoService.updateEstado(id, activo);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al actualizar estado');
        }
    }
);

export const asignarEmpleadoGeocercas = createAsyncThunk(
    'empleados/asignarGeocercas',
    async ({ id, geocercaIds }, { rejectWithValue }) => {
        try {
            return await EmpleadoService.asignarGeocercas(id, geocercaIds);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al asignar geocercas');
        }
    }
);

const empleadosSlice = createSlice({
    name: 'empleados',
    initialState: {
        list: [],
        pagination: { current: 1, pageSize: 15, total: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearEmpleadosError: (state) => { state.error = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmpleados.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchEmpleados.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.data;
                state.pagination = {
                    current: action.payload.meta.current_page,
                    pageSize: action.payload.meta.per_page,
                    total: action.payload.meta.total,
                };
            })
            .addCase(fetchEmpleados.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createEmpleado.fulfilled, (state) => { state.loading = false; })
            .addCase(updateEmpleado.fulfilled, (state) => { state.loading = false; })
            .addCase(deleteEmpleado.fulfilled, (state, action) => {
                state.list = state.list.filter((e) => e.id !== action.payload);
            })
            .addCase(updateEmpleadoEstado.fulfilled, (state, action) => {
                const updated = action.payload.empleado;
                if (updated) {
                    state.list = state.list.map((e) => (e.id === updated.id ? updated : e));
                }
            });
    },
});

export const { clearEmpleadosError } = empleadosSlice.actions;
export default empleadosSlice.reducer;